/* eslint-disable require-yield */
import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import { getFilterInitialAllData } from 'src/store/requests/filter/selector';
import { IFilterAllData, IFilterData, ListOfKeysFilterAllData } from 'src/typings/filter';
import { requestSelectors } from 'src/store/requests/selectors';
import { countRatingBySection, getSectionIdByMaxRating } from 'src/helpers/sectionRatingHelpers';
import { IFirstSpinner } from 'src/typings/spinner';
import { getSelectedHouse } from 'src/store/floors/selectors';
import { Actions, ActionTypes } from './actions';

export function* setSectionsDataSaga(actions: {
  type: string,
  payload: string[]
}) {
  const markup = actions.payload;
  const filterAllData: IFilterData = yield select(getFilterInitialAllData);
  const typeOfProperty: string = yield select(requestSelectors.typeOfProperty.getSelectedPlacement);
  const selectedHouse: IFirstSpinner | null = yield select(getSelectedHouse);
  const list: IFilterAllData[] = Object.values(
    filterAllData?.[typeOfProperty]?.filter_all_data ?? {},
  );
  const sectionRating: Record<string, number> = yield call(countRatingBySection, list, selectedHouse?.['name-id']);
  const sectionIdByMaxRating: string | null = yield call(getSectionIdByMaxRating, sectionRating);
  const markupId: string | null | undefined = markup?.[0] || sectionIdByMaxRating || list?.[0]?.[ListOfKeysFilterAllData.section];
  if (markupId) {
    yield put(Actions.setSelectedSection({
      markup: 'section_id',
      'markup-id': markupId,
    }));
    yield put(Actions.setSelectedFloor(undefined));
  }
}

export function* setFloorsDataWatchSaga() {
  yield takeEvery(ActionTypes.SET_FILTERED_SECTIONS, setSectionsDataSaga);
}
